import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import _possibleConstructorReturn from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/getPrototypeOf";
import _inherits from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/inherits";
import axios from "axios";
import BaseData from "./BaseData";

var ComplianceInspection8823Date =
/*#__PURE__*/
function (_BaseData) {
  _inherits(ComplianceInspection8823Date, _BaseData);

  function ComplianceInspection8823Date() {
    _classCallCheck(this, ComplianceInspection8823Date);

    return _possibleConstructorReturn(this, _getPrototypeOf(ComplianceInspection8823Date).call(this, "ComplianceInspection8823Date"));
  }

  _createClass(ComplianceInspection8823Date, [{
    key: "GetInspectionRelatedRows",
    value: function () {
      var _GetInspectionRelatedRows = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(inspectionId) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", axios.get("/api/".concat(this._controller, "/GetInspectionRelatedRows/").concat(inspectionId)));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function GetInspectionRelatedRows(_x) {
        return _GetInspectionRelatedRows.apply(this, arguments);
      }

      return GetInspectionRelatedRows;
    }()
  }]);

  return ComplianceInspection8823Date;
}(BaseData);

export default new ComplianceInspection8823Date();